import { useSyncExternalStore } from 'react';

// Text is measured with a canvas (see svgGenerator.measureTextWidth), which only knows a web font once
// it has loaded. This counter changes whenever a font finishes loading, so components that lay text out
// during render can measure again with the real font instead of keeping the fallback-font result.

let version = 0;
const listeners = new Set<() => void>();
let attached = false;

function bump() {
  version++;
  listeners.forEach(listener => listener());
}

function attach() {
  if (attached || typeof document === 'undefined' || !document.fonts) return;
  attached = true;
  document.fonts.addEventListener('loadingdone', bump);
  document.fonts.ready.then(bump);
}

function subscribe(listener: () => void) {
  attach();
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function useFontsVersion(): number {
  return useSyncExternalStore(subscribe, () => version, () => 0);
}
